import { ClientActions } from "../actions";

const initialState = {
  clients: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  client: null,
};

export default function client(state = initialState, action) {
  switch (action.type) {
    case ClientActions.ACTION_SAVE_CLIENTS:
      return {
        ...state,
        clients: action.payload,
      };
    case ClientActions.ACTION_SAVE_CLIENT:
      return {
        ...state,
        client: action.payload,
      };
    default:
      return state;
  }
}

export function getClients(state) {
  return state.client.clients;
}
export function getClient(state) {
  return state.client.client;
}
export function getClientLogins(state) {
  return state.client.clientLogins;
}
